Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supReset = exports.subReset = exports.subSupReset = exports.smallReset = exports.paragraphReset = void 0;
exports.paragraphReset = {
  ncss: {
    boxSizing: 'border-box',
    fontFamily: 'text'
  }
};
exports.smallReset = {
  ncss: Object.assign(Object.assign({}, exports.paragraphReset.ncss), {
    fontSize: '80%'
  })
};
exports.subSupReset = {
  ncss: Object.assign(Object.assign({}, exports.paragraphReset.ncss), {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
  })
};
exports.subReset = {
  ncss: Object.assign(Object.assign({}, exports.subSupReset.ncss), {
    bottom: '-0.25em'
  })
};
exports.supReset = {
  ncss: Object.assign(Object.assign({}, exports.subSupReset.ncss), {
    top: '-0.5em'
  })
};